// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SearchTypeRadio-module__wrapper___kzs5M","darkRadio":"SearchTypeRadio-module__darkRadio___hG5BY","focusedRadio":"SearchTypeRadio-module__focusedRadio___4+SZr"};